import { useContext, useEffect, useState } from 'react'

import { Box } from '@fairfashion/design-system'
import { useParams } from 'react-router-dom'

import { CustomTable } from '../Reports/components/custom-table.comp'
import { ReportsContext, ReportsProvider } from '../Reports/reports.context'

export const ReportComp = () => {
  const { reportResponse, reportFile, actions } = useContext(ReportsContext)
  const [page, setPage] = useState(1)

  const params = useParams()

  useEffect(() => {
    actions.getReport(params.report ?? '', page >= 1 ? page : 1, 50)
  }, [page, params.report])

  return reportResponse ? (
    <Box padding={3}>
      <CustomTable
        data={reportResponse.data}
        totalPages={Math.ceil(reportResponse.count / 50)}
        setPage={setPage}
        page={page}
        link={reportFile}
      />
    </Box>
  ) : null
}

export const Report = () => {
  return (
    <ReportsProvider>
      <ReportComp />
    </ReportsProvider>
  )
}
